import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// NOTE: auth is carried via the Bearer token (localStorage) set in the request
// interceptor below, so cross-site cookies are not needed. We keep
// withCredentials=false because the platform ingress returns
// `Access-Control-Allow-Origin: *`, which browsers reject when combined with
// credentialed requests (would surface as "Sem ligação ao servidor").
const api = axios.create({ baseURL: API, withCredentials: false });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const path = window.location.pathname;
    if (status === 401 && localStorage.getItem("token") && !["/login", "/register", "/verify-email", "/forgot-password", "/reset-password", "/set-password"].includes(path)) {
      localStorage.removeItem("token");
      window.location.href = "/login?expired=1";
      return Promise.reject(error);
    }
    if (status === 402) {
      if (path !== "/pricing") {
        window.location.href = "/pricing";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API };
